import { InputLabel } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { ImCross } from "react-icons/im";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossGrayIcon.svg";
import { InputLabelStyle, InputStyle } from "../../form-fields-mui/ASelect";
import { ReactComponent as SearchIcon } from "../../../../../../assets/img/svg/SearchIcon.svg";
import styles from "./styles.module.scss";
import { regexValidate } from "../../utils/methods/commonMethods/utilityMethod";

const AInput = ({
  className,
  style,
  innerRef,
  customSearchIconStyle,
  customCrossIconStyle,
  label,
  value,
  handler = () => {},
  placeholder,
  onKeyDown,
  crossHandler = () => {},
  type = "text",
  crossIcon = false,
  searchIcon = false,
  rightSearchIcon = false,
  searchIconClickHandler = () => {},
  customIcon,
  customIconStyle = {},
  rightCustomIcon,
  rightCustomIconStyles = {},
  loading = false,
  onKeyPress,
  regex,
  error = false,
  labelStyle = {},
  onPaste=false,
  ...props
}) => {
  const [cursor, setCursor] = useState(null);
  const ref = useRef(null);
  useEffect(() => {
    const input = ref.current;
    if (input) type === "text" && input.setSelectionRange(cursor, cursor);
  }, [ref, cursor, value, type]);

  const crossIconStyle = {
    fontSize: "11px",
    position: "absolute",
    top: "0",
    bottom: "0",
    margin: "auto 0",
    right: rightSearchIcon ? "50px" : "0.7rem",
    cursor: props?.disabled ? "default" : "pointer",
    ...customCrossIconStyle,
  };
  const searchIconStyle = {
    fontSize: "11px",
    position: "absolute",
    top: "0",
    bottom: "0",
    left: "5px",
    margin: "auto 0",
    cursor: props?.disabled ? "default" : "pointer",
    ...customSearchIconStyle,
  };
  const rightSearchIconStyle = {
    fontSize: "11px",
    position: "absolute",
    top: "0",
    bottom: "0",
    right: "16px",
    margin: "auto",
    cursor: props?.disabled ? "default" : "pointer",
  };

  const loadingStyle = {
    fontSize: "20px",
    position: "absolute",
    top: "10px",
    right: "5px",
    margin: "auto",
    cursor: "pointer",
  };

  const customIconStyles = {
    position: "absolute",
    display: "flex",
    alignItems: "center",
    top: "0",
    bottom: "0",
    margin: "auto 0",
    ...customIconStyle,
  };

  const paddingCross = crossIcon ? { paddingRight: "25px" } : {};
  const paddingSearch = searchIcon ? { paddingLeft: "27px" } : {};

  return (
    <>
      {label && (
        <InputLabel sx={{ ...InputLabelStyle, ...labelStyle }}>
          {label}
        </InputLabel>
      )}
      <div
        style={{ position: "relative" }}
        className={`${styles["custom-ainput"]} ${
          error ? styles["custom-input-error"] : ""
        }`}
      >
        {searchIcon && (
          <SearchIcon
            className="input_search_icon"
            onClick={props?.disabled ? () => {} : searchIconClickHandler}
            style={searchIconStyle}
          />
        )}
        {customIcon && <span style={customIconStyles}>{customIcon}</span>}
        <input
          value={value == undefined ? "" : value} //checking whether value is null or undefined
          onChange={(e) => {
            if (regexValidate(regex, e.target.value)) {
              handler(e.target.value, e);
              setCursor(e.target.selectionStart);
            }
          }}
          onPaste={onPaste?(e)=>{
        let pastedText = e.clipboardData?.getData("text/plain");
      if (regexValidate(regex?.numeric, pastedText)) 
          handler(pastedText,e)
          e.preventDefault();
          }:()=>{}
          }
          onKeyDown={onKeyDown}
          onKeyPress={onKeyPress}
          placeholder={placeholder}
          type={type}
          className={className}
          style={{
            ...InputStyle,
            border: "1px solid #CFD3D4",
            ...paddingCross,
            ...paddingSearch,
            ...style,
          }}
          key="random1"
          ref={innerRef || ref}
          {...props}
        />
        {rightCustomIcon && (
          <span style={rightCustomIconStyles}>{rightCustomIcon}</span>
        )}
        {crossIcon && value?.length > 0 && (
          <CrossIcon
            onClick={props?.disabled ? () => {} : crossHandler}
            style={crossIconStyle}
          />
        )}
        {!loading && rightSearchIcon && (
          <SearchIcon
            className="input_search_icon"
            onClick={props?.disabled ? () => {} : searchIconClickHandler}
            style={rightSearchIconStyle}
          />
        )}
        {loading && (
          <i
            className="fas fa-circle-notch fa-spin"
            aria-hidden="true"
            style={loadingStyle}
          ></i>
        )}
      </div>
    </>
  );
};

export default AInput;
